import { IChatMessage } from '@app-types/websocket/chat.types';

interface IGraphemeSegmenter {
  segment:(text:string) => Iterable<unknown>;
}
type GraphemeSegmenterConstructor = new (locale:string|undefined, options:{granularity:'grapheme'}) => IGraphemeSegmenter;

// Reactions and replies both point at another message through questionId. One character
// (a single emoji) is a reaction and shows on the message it points at; anything longer,
// or an attachment, is a reply and shows as a message of its own.
export function isReaction(message:IChatMessage):boolean {
  return typeof message.questionId === 'number' && message.questionId > 0
    && message.fileDesc === undefined && message.callId === undefined
    && isSingleCharacter(typeof message.msg === 'string' ? message.msg : '');
}

// One user-perceived character, so an emoji built from several code points (❤️, 👍🏽, 👨‍👩‍👧) counts as one.
export function isSingleCharacter(text:string):boolean {
  const trimmed = text.trim();
  if (trimmed === '') {
    return false;
  }

  const Segmenter:GraphemeSegmenterConstructor|undefined = (Intl as any).Segmenter;
  if (typeof Segmenter === 'function') {
    return Array.from(new Segmenter(undefined, {granularity:'grapheme'}).segment(trimmed)).length === 1;
  }

  // WebViews without Intl.Segmenter: skip the variation selectors, keycaps and skin tones
  // that dress up an emoji, and the code point a zero-width joiner glues onto it.
  const codePoints = Array.from(trimmed);
  let characters = 0;
  for (let index = 0; index < codePoints.length; index++) {
    const codePoint = codePoints[index].codePointAt(0) || 0;
    if (codePoint === 0x200D) {
      index++;
    } else if (codePoint !== 0xFE0E && codePoint !== 0xFE0F && codePoint !== 0x20E3
      && (codePoint < 0x1F3FB || codePoint > 0x1F3FF)) {
      characters++;
    }
  }
  return characters === 1;
}

// What a reply shows of the message it answers: its text, or else the name of its attachment.
export function replyPreviewText(message:IChatMessage|undefined):string {
  if (message === undefined) {
    return '';
  }
  const text = typeof message.msg === 'string' ? message.msg.trim() : '';
  if (text !== '') {
    return text;
  }
  return message.fileDesc && typeof message.fileDesc.fileName === 'string' ? message.fileDesc.fileName : '';
}



// WEBPACK FOOTER //
// ./src/services/chat/chatReply.ts